import 'number-flow';
import { continuous } from 'number-flow';

function statsCounter() {
  const counters = document.querySelectorAll('.animCounter');

  if (!counters.length) return;

  counters.forEach((counter) => {
    const text = counter.textContent.trim();

    // Extract optional prefix, numeric value (with commas/decimals), and optional suffix
    const match = text.match(/^([^0-9]*)([0-9][0-9,.]*)([^0-9]*)$/);

    if (!match) return;

    const prefix = match[1];
    const numberStr = match[2];
    const suffix = match[3];
    const hasCommas = numberStr.includes(',');
    const hasDecimals = numberStr.includes('.');
    const targetValue = parseFloat(numberStr.replace(/,/g, ''));

    if (isNaN(targetValue)) return;

    const flow = document.createElement('number-flow');

    if (prefix) flow.numberPrefix = prefix;
    if (suffix) flow.numberSuffix = suffix;

    flow.format = {
      useGrouping: hasCommas,
      minimumFractionDigits: hasDecimals ? 1 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0,
    };

    flow.plugins = [continuous];

    flow.transformTiming = { duration: 0 };
    flow.spinTiming = { duration: 1400, easing: 'ease-out' };
    flow.opacityTiming = { duration: 600, easing: 'ease-out' };

    flow.style.lineHeight = 'inherit';
    flow.style.fontVariantNumeric = 'tabular-nums';

    counter.textContent = '';
    counter.appendChild(flow);

    // Set initial value (first .update() is non-animated)
    flow.update(0);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            flow.update(targetValue);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(counter);
  });
}

export { statsCounter };
